import * as constants from './constants';

export function fetchPpsi(id) {
  return {
    type: constants.FETCH_PPSI,
    payload: id
  };
}

export function fetchPpsiDone(ppsi) {
  return {
    type: constants.FETCH_PPSI_DONE,
    payload: ppsi
  };
}

export function fetchPpsiFail(error) {
  return {
    type: constants.FETCH_PPSI_FAIL,
    payload: error
  };
}

// CREATE PPSI VARIANT

export function createPpsiVariant(id, status) {
  return {
    type: constants.CREATE_PPSI_VARIANT,
    payload: { id, status }
  };
}

export function createPpsiVariantDone(ppsi) {
  return {
    type: constants.CREATE_PPSI_VARIANT_DONE,
    payload: ppsi
  };
}

export function createPpsiVariantFail(error) {
  return {
    type: constants.CREATE_PPSI_VARIANT_FAIL,
    payload: error
  };
}

export function deletePpsi(ids) {
  return {
    type: constants.DELETE_PPSI,
    payload: ids
  };
}

export function deletePpsiDone(ppsi) {
  return {
    type: constants.DELETE_PPSI_DONE,
    payload: ppsi
  };
}

export function deletePpsiFail(error) {
  return {
    type: constants.DELETE_PPSI_FAIL,
    payload: error
  };
}

export function fetchPpsis(filter) {
  return {
    type: constants.FETCH_PPSIS,
    payload: filter
  };
}

export function fetchPpsisDone(ppsis) {
  return {
    type: constants.FETCH_PPSIS_DONE,
    payload: ppsis
  };
}

export function fetchPpsisFail(error) {
  return {
    type: constants.FETCH_PPSIS_FAIL,
    payload: error
  };
}
export function fetchPublishedUnpublishedPpsis() {
  return {
    type: constants.FETCH_PUBLISHED_UNPUBLISHED_PPSIS
  };
}

export function fetchPublishedUnpublishedPpsisDone(ppsis) {
  return {
    type: constants.FETCH_PUBLISHED_UNPUBLISHED_PPSIS_DONE,
    payload: ppsis
  };
}

export function fetchPublishedUnpublishedPpsisFail(error) {
  return {
    type: constants.FETCH_PUBLISHED_UNPUBLISHED_PPSIS_FAIL,
    payload: error
  };
}
export function fetchPpsisUpdates(filter) {
  return {
    type: constants.UPDATES_PPSIS,
    payload: filter
  };
}

export function fetchPpsisUpdatesDone(ppsis) {
  return {
    type: constants.UPDATES_PPSIS_DONE,
    payload: ppsis
  };
}

export function fetchPpsisUpdatesFail(error) {
  return {
    type: constants.UPDATES_PPSIS_FAIL,
    payload: error
  };
}

export function fetchGlobalPpsisUpdates(filter) {
  return {
    type: constants.UPDATES_GLOBAL_PPSIS,
    payload: filter
  };
}

export function fetchGlobalPpsisUpdatesDone(ppsis) {
  return {
    type: constants.UPDATES_GLOBAL_PPSIS_DONE,
    payload: ppsis
  };
}

export function fetchGlobalPpsisUpdatesFail(error) {
  return {
    type: constants.UPDATES_GLOBAL_PPSIS_FAIL,
    payload: error
  };
}

export function fetchGlobalPpsi(id) {
  return {
    type: constants.FETCH_PPSI_GLOBAL,
    payload: id
  };
}

export function fetchGlobalPpsiCopy(id) {
  return {
    type: constants.FETCH_PPSI_GLOBAL_COPY,
    payload: id
  };
}

export function fetchGlobalPpsis() {
  return {
    type: constants.FETCH_PPSIS_GLOBAL
  };
}

export function fetchGlobalNewPpsis() {
  return {
    type: constants.FETCH_PPSIS_NEW_GLOBAL
  };
}

export function createPpsi(formulaCode, ppsi, callback, productAreaData) {
  return {
    type: constants.CREATE_PPSI,
    payload: {
      formulaCode,
      ppsi,
      callback,
      productAreaData
    }
  };
}

export function createPpsiDone(ppsi) {
  return {
    type: constants.CREATE_PPSI_DONE,
    payload: ppsi
  };
}

export function createPpsiFail(error) {
  return {
    type: constants.CREATE_PPSI_FAIL,
    payload: error
  };
}

export function savePpsi(id, ppsi, callback, productAreaData) {
  return {
    type: constants.SAVE_PPSI,
    payload: { id, ppsi, callback, productAreaData }
  };
}

export function savePpsiDone(ppsi) {
  return {
    type: constants.SAVE_PPSI_DONE,
    payload: ppsi
  };
}

export function savePpsiFail(error) {
  return {
    type: constants.SAVE_PPSI_FAIL,
    payload: error
  };
}

export function approvePpsi(id, data) {
  return {
    type: constants.APPROVE_PPSI,
    payload: { id, data }
  };
}

export function approvePpsiDone(ppsi) {
  return {
    type: constants.APPROVE_PPSI_DONE,
    payload: ppsi
  };
}

export function approvePpsiFail(error) {
  return {
    type: constants.APPROVE_PPSI_FAIL,
    payload: error
  };
}

export function publishPpsi(id) {
  return {
    type: constants.PUBLISH_PPSI,
    payload: { id }
  };
}

export function publishPpsiDone(ppsi) {
  return {
    type: constants.PUBLISH_PPSI_DONE,
    payload: ppsi
  };
}

export function publishPpsiFail(error) {
  return {
    type: constants.PUBLISH_PPSI_FAIL,
    payload: error
  };
}

export function unpublishPpsi(id) {
  return {
    type: constants.UNPUBLISH_PPSI,
    payload: { id }
  };
}

export function unpublishPpsiDone(ppsi) {
  return {
    type: constants.UNPUBLISH_PPSI_DONE,
    payload: ppsi
  };
}

export function unpublishPpsiFail(error) {
  return {
    type: constants.UNPUBLISH_PPSI_FAIL,
    payload: error
  };
}

export function markAsUptoDatePpsi(id) {
  return {
    type: constants.MARK_AS_UPTODATE_PPSI,
    payload: { id }
  };
}

export function markAsUptoDatePpsiDone(ppsi) {
  return {
    type: constants.MARK_AS_UPTODATE_PPSI_DONE,
    payload: ppsi
  };
}

export function markAsUptoDatePpsiFail(error) {
  return {
    type: constants.MARK_AS_UPTODATE_PPSI_FAIL,
    payload: error
  };
}

export function createDraftPpsi(id, status) {
  return {
    type: constants.CREATE_DRAFT_PPSI,
    payload: {
      id,
      ...(status === constants.States.SCHEDULED ||
      status === constants.States.GLOBALREVIEW
        ? { status }
        : '')
    }
  };
}

export function createDraftPpsiDone(ppsi) {
  return {
    type: constants.CREATE_DRAFT_PPSI_DONE,
    payload: ppsi
  };
}

export function createDraftPpsiFail(error) {
  return {
    type: constants.CREATE_DRAFT_PPSI_FAIL,
    payload: error
  };
}

// IMPORT Ifood ppsi update

export function importiFoodUpdatePpsi(id) {
  return {
    type: constants.IMPORT_IFOOD_UPDATE_PPSI,
    payload: { id }
  };
}

export function importiFoodUpdatePpsiDone(ppsi) {
  return {
    type: constants.IMPORT_IFOOD_UPDATE_PPSI_DONE,
    payload: ppsi
  };
}

export function importiFoodUpdatePpsiFail(error) {
  return {
    type: constants.IMPORT_IFOOD_UPDATE_PPSI_FAIL,
    payload: error
  };
}

// PPSI Discard draft actions

export function discardDraftPpsi(id) {
  return {
    type: constants.DISCARD_DRAFT_PPSI,
    payload: { id }
  };
}

export function discardDraftPpsiDone(ppsi) {
  return {
    type: constants.DISCARD_DRAFT_PPSI_DONE,
    payload: ppsi
  };
}

export function discardDraftPpsiFail(error) {
  return {
    type: constants.DISCARD_DRAFT_PPSI_FAIL,
    payload: error
  };
}

// Total range dish statistic actions

export function totalRangePpsi(market) {
  return {
    type: constants.FETCH_TOTAL_RANGE_REPORT,
    payload: { market }
  };
}

export function totalRangePpsiDone(data) {
  return {
    type: constants.FETCH_TOTAL_RANGE_REPORT_DONE,
    payload: data
  };
}

export function totalRangePpsiFail(error) {
  return {
    type: constants.FETCH_TOTAL_RANGE_REPORT_FAIL,
    payload: error
  };
}

// IMPORT Global ppsi update

export function importGlobalUpdatePpsi(id) {
  return {
    type: constants.IMPORT_GLOBAL_UPDATE_PPSI,
    payload: { id }
  };
}

export function importGlobalUpdatePpsiDone(ppsi) {
  return {
    type: constants.IMPORT_GLOBAL_UPDATE_PPSI_DONE,
    payload: ppsi
  };
}

export function importGlobalUpdatePpsiFail(error) {
  return {
    type: constants.IMPORT_GLOBAL_UPDATE_PPSI_FAIL,
    payload: error
  };
}

// fetch global revieww PPSI and filter with status

export function fetchReviewPpsis(filter, marketCode) {
  return {
    type: constants.FETCH_REVIEW_PPSIS,
    payload: { filter, marketCode }
  };
}

export function fetchReviewPpsisDone(ppsis) {
  return {
    type: constants.FETCH_REVIEW_PPSIS_DONE,
    payload: ppsis
  };
}

export function fetchReviewPpsisFail(error) {
  return {
    type: constants.FETCH_REVIEW_PPSIS_FAIL,
    payload: error
  };
}

// fetch global revieww PPSI summary

export function fetchPpsisReviewSummary(market, count, history) {
  return {
    type: constants.FETCH_PPSIS_REVIEW_SUMMARY,
    ...(market && count ? { payload: { market, count, history } } : '')
  };
}

export function fetchPpsisReviewSummaryDone(ppsis, conditionCheck) {
  return {
    type: constants.FETCH_PPSIS_REVIEW_SUMMARY_DONE,
    payload: { ppsis, conditionCheck }
  };
}

export function fetchPpsisReviewSummaryFail(error) {
  return {
    type: constants.FETCH_PPSIS_REVIEW_SUMMARY_FAIL,
    payload: error
  };
}

// fetch review PPSI for Global approval

export function fetchGlobalApprovalPpsi(marketCode, id) {
  return {
    type: constants.FETCH_GLOBAL_APPROVAL_PPSI,
    payload: { marketCode, id }
  };
}

export function fetchGlobalApprovalPpsiDone(ppsi) {
  return {
    type: constants.FETCH_GLOBAL_APPROVAL_PPSI_DONE,
    payload: ppsi
  };
}

export function fetchGlobalApprovalPpsiFail(error) {
  return {
    type: constants.FETCH_GLOBAL_APPROVAL_PPSI_FAIL,
    payload: error
  };
}

// send dish for global review

export function sendPpsiForGlobalReview(id, data) {
  return {
    type: constants.SUBMIT_FOR_REVIEW_PPSI,
    payload: { id, data }
  };
}

export function sendPpsiForGlobalReviewDone(ppsi) {
  return {
    type: constants.SUBMIT_FOR_REVIEW_PPSI_DONE,
    payload: ppsi
  };
}

export function sendPpsiForGlobalReviewFail(error) {
  return {
    type: constants.SUBMIT_FOR_REVIEW_PPSI_FAIL,
    payload: error
  };
}

//   reject ppsi by global admin

export function rejectGlobalReviewPpsi(id, data) {
  return {
    type: constants.GLOBAL_REJECT_REVIEW_PPSI,
    payload: { id, data }
  };
}

export function rejectGlobalReviewPpsiDone(ppsi) {
  return {
    type: constants.GLOBAL_REJECT_REVIEW_PPSI_DONE,
    payload: ppsi
  };
}

export function rejectGlobalReviewPpsiFail(error) {
  return {
    type: constants.GLOBAL_REJECT_REVIEW_PPSI_FAIL,
    payload: error
  };
}

// global approve ppsi

export function approveGlobalReviewPpsi(marketCode, id) {
  return {
    type: constants.GLOBAL_APPROVE_REVIEW_PPSI,
    payload: { marketCode, id }
  };
}

export function approveGlobalReviewPpsiDone(ppsi) {
  return {
    type: constants.GLOBAL_APPROVE_REVIEW_PPSI_DONE,
    payload: ppsi
  };
}

export function approveGlobalReviewPpsiFail(error) {
  return {
    type: constants.GLOBAL_APPROVE_REVIEW_PPSI_FAIL,
    payload: error
  };
}

export function hasRecalledPPSIError(error) {
  return {
    type: constants.HAS_RECALLED_PPSI_ERROR,
    payload: error
  };
}

export function navigateToReviewPage(market, objects, history) {
  return {
    type: constants.NAVIGATE_TO_REVIEW,
    payload: { market, objects, history }
  };
}

export function navigateToReviewPageDone(countAndMarket) {
  return {
    type: constants.NAVIGATE_TO_REVIEW_DONE,
    payload: countAndMarket
  };
}

export function navigateToReviewPageFail(error) {
  return {
    type: constants.NAVIGATE_TO_REVIEW_FAIL,
    payload: error
  };
}

export function fetchRecalledErrorForOne(id, history) {
  return {
    type: constants.FETCH_RECALLED_ERROR_ONE,
    payload: { id, history }
  };
}

export function fetchRecalledErrorForOneDone(ppsi) {
  return {
    type: constants.FETCH_RECALLED_ERROR_ONE_DONE,
    payload: ppsi
  };
}

export function fetchRecalledErrorForOneFail(error) {
  return {
    type: constants.FETCH_RECALLED_ERROR_ONE_FAIL,
    payload: error
  };
}

// fetch ppsi with global status

export function fetchGlobalStatusPpsi() {
  return {
    type: constants.FETCH_GLOBAL_STATUS_PPSIS
  };
}

export function fetchGlobalStatusPpsiDone(ppsis) {
  return {
    type: constants.FETCH_GLOBAL_STATUS_PPSIS_DONE,
    payload: ppsis
  };
}

export function fetchGlobalStatusPpsiFail(error) {
  return {
    type: constants.FETCH_GLOBAL_STATUS_PPSIS_FAIL,
    payload: error
  };
}

// IFPPSI-954 - Publish empty PPSI option for global admin;

export function publishEmptyPpsi(id) {
  return {
    type: constants.PUBLISH_EMPTY_PPSI,
    payload: { id }
  };
}

export function publishEmptyPpsiDone(ppsi) {
  return {
    type: constants.PUBLISH_EMPTY_PPSI_DONE,
    payload: ppsi
  };
}

export function publishEmptyPpsiFail(error) {
  return {
    type: constants.PUBLISH_EMPTY_PPSI_FAIL,
    payload: error
  };
}

// Co-worker Engagement Report actions

export function fetchCoWorkerEngagementReport(market) {
  // console.log(market,"Action")
  return {
    type: constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT,
    payload: market
  };
}

export function fetchCoWorkerEngagementReportDone(data) {
  return {
    type: constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_DONE,
    payload: data
  };
}

export function fetchCoWorkerEngagementReportFail(error) {
  return {
    type: constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_FAIL,
    payload: error
  };
}

// Co-worker Engagement Report Market List actions

export function fetchCoWorkerEngagementReportMarketList(market) {
  // console.log(market,"Action")
  return {
    type: constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST,
    payload: market
  };
}

export function fetchCoWorkerEngagementReportMarketListDone(data) {
  return {
    type: constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST_DONE,
    payload: data
  };
}

export function fetchCoWorkerEngagementReportMarketListFail(error) {
  return {
    type: constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST_FAIL,
    payload: error
  };
}

// Actions for uploading BOM Reports in NIR Markets
export function uploadBomReport(file) {
  return {
    type: constants.UPLOAD_BOM_REPORT,
    payload: file
  };
}

export function uploadBomReportSuccess(message) {
  return {
    type: constants.UPLOAD_BOM_REPORT_SUCCESS,
    payload: message
  };
}

export function uploadBomReportFailure(error) {
  return {
    type: constants.UPLOAD_BOM_REPORT_FAILURE,
    payload: error
  };
}

export function uploadBomReportReset() {
  return {
    type: constants.UPLOAD_BOM_REPORT_RESET
  };
}

// Actions for fetching non-market specific Global PPSI:s for Nir markets
export function fetchGlobalPpsisNir(status, toLocalLanguage) {
  return {
    type: constants.FETCH_GLOBAL_PPSIS_NIR,
    payload: { status, toLocalLanguage }
  };
}

export function fetchGlobalPpsisNirDone(ppsis) {
  return {
    type: constants.FETCH_GLOBAL_PPSIS_NIR_DONE,
    payload: ppsis
  };
}

export function fetchGlobalPpsisNirFail(error) {
  return {
    type: constants.FETCH_GLOBAL_PPSIS_NIR_FAIL,
    payload: error
  };
}

// Actions for creating a NIR PPSI from a Global non-market specific PPSI
export function fetchRaPaNir() {
  return {
    type: constants.FETCH_RA_PA_NIR
  };
}

export function fetchRaPaNirDone(payload) {
  return {
    type: constants.FETCH_RA_PA_NIR_DONE,
    payload: payload
  };
}

export function fetchRaPaNirFail(error) {
  return {
    type: constants.FETCH_RA_PA_NIR_FAIL,
    payload: error
  };
}

//Actions for creating a NIR PPSI from a Global non-market specific PPSI
export function createPpsiFromGlobalNir(
  formulaCode,
  ppsi,
  productAreaData,
  globalPiaArticleNumber,
  callback
) {
  return {
    type: constants.CREATE_PPSI_FROM_GLOBAL_NIR,
    payload: {
      formulaCode,
      ppsi,
      productAreaData,
      globalPiaArticleNumber,
      callback
    }
  };
}

// Discard draft PPSI for NIR Markets
export function discardDraftPpsiNir(id, formulaCode) {
  return {
    type: constants.DISCARD_DRAFT_PPSI_NIR,
    payload: { id, formulaCode }
  };
}

// Delete PPSI for NIR Markets
export function deletePpsiNir(ids, formulaCodes) {
  return {
    type: constants.DELETE_PPSI_NIR,
    payload: { ids, formulaCodes }
  };
}

// ApprovePPSI for NIR Markets
export function approvePpsiNir(id, data) {
  return {
    type: constants.APPROVE_PPSI_NIR,
    payload: { id, data }
  };
}

// ApprovePPSI for NIR Markets
export function approveGlobalPpsiNir(marketCode, id) {
  return {
    type: constants.APPROVE_PPSI_NIR,
    payload: { marketCode, id }
  };
}

// //Fetch global PPi IFS Market for local market
// export function fetchGlobalPpiIfs(id) {
//   return {
//     type: constants.FETCH_GLOBAL_PPI_IFS,
//     payload: id
//   };
// }

// export function fetchGlobalPpiIfsDone(ppis) {
//   return {
//     type: constants.FETCH_GLOBAL_PPI_IFS_DONE,
//     payload: ppis
//   };
// }

// export function fetchGlobalPpiIfsFail(error) {
//   return {
//     type: constants.FETCH_GLOBAL_PPI_IFS_FAIL,
//     payload: error
//   };
// }

// Fetch Market Dish Logo
export function fetchMarketDishLogo() {
  return {
    type: constants.FETCH_MARKET_DISH_LOGO
  };
}

export function fetchMarketDishLogoDone(ppis) {
  return {
    type: constants.FETCH_MARKET_DISH_LOGO_DONE,
    payload: ppis
  };
}

export function fetchMarketDishLogoFail(error) {
  return {
    type: constants.FETCH_MARKET_DISH_LOGO_FAIL,
    payload: error
  };
}

export function setPPSIId(id) {
  return {
    type: constants.SET_PPSI_ID,
    payload: id
  };
}
export function showPopUp(show) {
  return {
    type: constants.SHOW_POP_UP,
    payload: show
  };
}
// save availablity tab
export function saveAvailabilityTab(id, status, data, callback) {
  return {
    type: constants.SAVE_AVAILABILITY_TAB,
    payload: { id, status, data, callback }
  };
}

export function saveAvailabilityTabDone(ppsi) {
  return {
    type: constants.SAVE_AVAILABILITY_TAB_DONE,
    payload: ppsi
  };
}

export function saveAvailabilityTabFail(error) {
  return {
    type: constants.SAVE_AVAILABILITY_TAB_FAIL,
    payload: error
  };
}
export function isEnableAvailablity(payload) {
  return {
    type: constants.IS_ENABLE_AVAILABLITY,
    payload
  };
}
